module.exports = __webpack_public_path__ + "img/2-5.a6b5ae2.svg";